import script from "./GridEditorNoteManager.vue?vue&type=script&setup=true&lang=js"
export * from "./GridEditorNoteManager.vue?vue&type=script&setup=true&lang=js"

import "./GridEditorNoteManager.vue?vue&type=style&index=0&id=a83218e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a83218e4"]])

export default __exports__